"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = require("./global");
var ModuleLoader = /** @class */ (function () {
    function ModuleLoader() {
        this.importTask = {};
    }
    ModuleLoader.prototype.load = function (starkModule, fetch) {
        if (fetch === void 0) { fetch = window.fetch; }
        var url = starkModule.url, name = starkModule.name;
        if (this.importTask[name]) {
            // return promise if current module is pending or resolved
            return this.importTask[name];
        }
        var urls = Array.isArray(url) ? url : [url];
        var task = Promise.all(urls.map(function (scriptUrl) { return fetch(scriptUrl)
            .then(function (res) { return res.text(); })
            .then(function (res) { return res + " \n //# sourceURL=" + scriptUrl; }); }));
        this.importTask[name] = task;
        return task;
    };
    ModuleLoader.prototype.removeTask = function (name) {
        delete this.importTask[name];
    };
    ModuleLoader.prototype.clearTask = function () {
        this.importTask = {};
    };
    ModuleLoader.prototype.execModule = function (starkModule, sandbox, deps) {
        return this.load(starkModule).then(function (sources) {
            var globalWindow = null;
            if (sandbox === null || sandbox === void 0 ? void 0 : sandbox.getSandbox) {
                sandbox.createProxySandbox(deps);
                globalWindow = sandbox.getSandbox();
            }
            else {
                globalWindow = window;
            }
            var name = starkModule.name;
            var libraryExport = '';
            // excute script in order
            try {
                sources.forEach(function (source, index) {
                    var lastScript = index === sources.length - 1;
                    if (lastScript) {
                        global_1.noteGlobalProps(globalWindow);
                    }
                    // check sandbox
                    if (sandbox === null || sandbox === void 0 ? void 0 : sandbox.execScriptInSandbox) {
                        sandbox.execScriptInSandbox(source);
                    }
                    else {
                        // https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/eval
                        // eslint-disable-next-line no-eval
                        (0, eval)(source);
                    }
                    if (lastScript) {
                        libraryExport = global_1.getGlobalProp(globalWindow);
                    }
                });
            }
            catch (err) {
                console.error(err);
            }
            var moduleInfo = libraryExport ? globalWindow[libraryExport] : (globalWindow[name] || {});
            // remove moduleInfo from globalWindow in case of excute multi module in globalWindow
            if (globalWindow[libraryExport]) {
                delete globalWindow[libraryExport];
            }
            return moduleInfo;
        });
    };
    return ModuleLoader;
}());
exports.default = ModuleLoader;
